import { Pipe, PipeTransform } from '@angular/core';
import { MonthlyPensionAccountDetails } from '../../../../../../../models/transactions/monthly-pension-account-details';

@Pipe({
  name: 'monthlyPensionAnnuityTypeLabel',
  standalone: true
})
export class MonthlyPensionAnnuityTypeLabelPipe implements PipeTransform {
  transform(accountDetails?: Pick<MonthlyPensionAccountDetails, 'annuityType' | 'annuityGuaranteePeriod'>): string {
    if (!accountDetails) return '';

    return $localize`${accountDetails.annuityType?.name} – ${accountDetails.annuityGuaranteePeriod?.name} Guarantee`;
  }
}
